import React from 'react';
import { IonPage, IonContent} from '@ionic/react';
import ContributeCard from "../components/ContributeCard";

export default function ContributeDesktopPage({renderHeaderPage}) {

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent
                fullscreen
                className="contribute-content page-content">
                <div className="desktop-contain-contribute">
                    <ContributeCard/>
                </div>
            </IonContent>
        </IonPage>
    );
}
